import { removeToken } from 'helpers/common.helper';
import PerfectScrollbar from 'perfect-scrollbar';
import React, { useEffect, useRef } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Button, Nav } from 'reactstrap';
import { storeMe } from 'store/global/action';
import { useAppDispatch } from 'store/hooks';
import './Sidebar.scss';

let ps: any;

const Sidebar = (props: {
  bgColor?: string;
  activeColor?: string;
  routes?: any[];
}) => {
  const location = useLocation();
  const sidebar = useRef(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const activeRoute = (routeName: any) => {
    return location.pathname.indexOf(routeName) > -1 ? 'active' : '';
  };

  useEffect(() => {
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(sidebar?.current!, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf('Win') > -1) {
        ps.destroy();
      }
    };
  });

  const handleLogOut = () => {
    dispatch(storeMe(undefined));
    removeToken();
    navigate('/login');
  };

  return (
    <div
      className="sidebar"
      data-color={props.bgColor}
      data-active-color={props.activeColor}
    >
      <div className="logo">
        <a href="/" className="simple-text logo-normal">
          <img alt="image" src={require('assets/img/logo.png')} />
          <span>Beem</span>
        </a>
      </div>
      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav>
          {props.routes && props.routes.length
            ? props.routes.map((item: any, key: any) => {
                return (
                  <li
                    className={
                      activeRoute(item.path) + (item.pro ? ' active-pro' : '')
                    }
                    key={key}
                  >
                    <NavLink
                      to={item.path}
                      className="nav-NavLink !py-[0.2rem]"
                    >
                      <i className={`${item.icon} !text-[1.2rem]`} />
                      <p>{item.name}</p>
                    </NavLink>
                  </li>
                );
              })
            : null}
        </Nav>
        <Button className="btn btn-danger" onClick={handleLogOut}>
          Log Out
        </Button>
      </div>
    </div>
  );
};

export default Sidebar;
